import { render, staticRenderFns } from "./VerListaOcs.vue?vue&type=template&id=9abb7256&"
import script from "./VerListaOcs.vue?vue&type=script&lang=js&"
export * from "./VerListaOcs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports